import { MessageActionTypes } from './message.types';

export const setMessage = (value) => ({
  type: MessageActionTypes.SET_MESSAGE,
  payload: value,
});

export const setMessageType = (value) => ({
  type: MessageActionTypes.SET_MESSAGE_TYPE,
  payload: value,
});

export const setMessageSubject = (value) => ({
  type: MessageActionTypes.SET_MESSAGE_SUBJECT,
  payload: value,
});

export const setMessageHtml = (value) => ({
  type: MessageActionTypes.SET_MESSAGE_HTML,
  payload: value,
});

export const setMessageTemplateId = (value) => ({
  type: MessageActionTypes.SET_MESSAGE_TEMPLATE_ID,
  payload: value,
});

export const sendEmailSuccess = () => ({
  type: MessageActionTypes.SEND_EMAIL_SUCCESS,
});
export const sendEmailStart = () => ({
  type: MessageActionTypes.SEND_EMAIL_START,
});
export const sendEmailFailure = (error) => ({
  type: MessageActionTypes.SEND_EMAIL_FAILURE,
  payload: error,
});

export const sendTextSuccess = () => ({
  type: MessageActionTypes.SEND_TEXT_SUCCESS,
});
export const sendTextStart = () => ({
  type: MessageActionTypes.SEND_TEXT_START,
});
export const sendTextFailure = (error) => ({
  type: MessageActionTypes.SEND_TEXT_FAILURE,
  payload: error,
});

export const clearMessage = () => ({
  type: MessageActionTypes.SET_MESSAGE,
  payload: '',
});

export const setMessageData = (messageData) => ({
  type: MessageActionTypes.SET_MESSAGE_DATA,
  payload: messageData,
});
